module.exports = __webpack_public_path__ + "static/media/PATEL JI.00a3dc27.pdf";